import React from 'react';

import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';

import StageDotBadge from 'bundles/apex/deals/stages/dot_badge';
import TimelineRow from 'bundles/apex/activities/timeline_row';
import { stageActionText, stageLabel } from 'bundles/apex/deals/stages/helpers';

import type { StageOption, StageTimelineItem } from 'bundles/apex/activities/types';

interface Props {
  item: StageTimelineItem;
  stageOptions: StageOption[];
}

export default function TimelineStageRow({ item, stageOptions }: Props) {
  const { stageEvent } = item;
  const { deal, previousStage, stage, startTime, whodunnit } = stageEvent;
  const action = stageActionText(stageEvent);
  const badge = (value: string) => <StageDotBadge stage={value} stageLabel={stageLabel(value, stageOptions)} />;

  return (
    <TimelineRow
      actors={whodunnit && <span className="fw-semibold">{whodunnit.admin ? 'Buildout' : whodunnit.name}</span>}
      assoc={{ label: deal.name, path: deal.path }}
      icon={faArrowRight}
      subject={(
        <span className="d-inline-flex align-items-center flex-wrap gap-1">
          {action.charAt(0).toUpperCase() + action.slice(1)}
          {previousStage && <>{badge(previousStage)} to</>}
          {badge(stage)}
        </span>
      )}
      time={{ date: item.date, createdAt: startTime }}
    />
  );
}
